module.exports = __webpack_public_path__ + "static/media/施工後.9805a605.jpg";